import type { FC } from 'react';
import React from 'react';

import { RicosNodeContextProvider } from './../../../../../ricos-context/index.js';
import type { NodeViewRenderer, NodeViewRendererProps } from './../../../../../ricos-types/index.js';

import styles from './layout-scss.js';

export const LayoutCell: FC<NodeViewRendererProps> = ({ node, nodeIndex, RicosNodesRenderer }) => {
  return (
    <div className={styles.cell}>
      <RicosNodeContextProvider parentNode={node} parentIndex={nodeIndex}>
        <RicosNodesRenderer
          key={`children-${node.id}`}
          nodes={node.nodes ?? []}
          shouldParagraphApplyTextStyle
        />
      </RicosNodeContextProvider>
    </div>
  );
};

export const LayoutCellRenderer: NodeViewRenderer = ({ node, ...props }) => {
  return <LayoutCell key={node.id} node={node} {...props} />;
};
